module.exports = __webpack_public_path__ + "media/images/application/template/logos/placeholder-logo-square-41705bc114f6494f68460cd7f23b1d50.png";